import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

const api = axios.create({
  baseURL: API,
});

// Bearer token from localStorage (primary auth for frontend; cookies still work for backend-to-backend)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("vb_access_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Site context — set by SiteProvider; "all" / null means all-sites view.
  const siteCtx = localStorage.getItem("vb_active_site");
  if (siteCtx && siteCtx !== "all") config.headers["X-Site-Context"] = siteCtx;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401 && !err.config._retry) {
      err.config._retry = true;
      try {
        const r = await axios.post(`${API}/auth/refresh`, {});
        if (r.data?.access_token) {
          localStorage.setItem("vb_access_token", r.data.access_token);
          err.config.headers.Authorization = `Bearer ${r.data.access_token}`;
          return api(err.config);
        }
      } catch (e) {
        // Refresh failed — fall through to reject so caller routes to /login.
        console.debug("Token refresh failed:", e?.response?.status);
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
